import { State } from "data";

export const selectMemsqlOnline = (s: State): boolean =>
    Boolean(
        s.systemStatus.memsqlConnection &&
            s.systemStatus.memsqlConnection.active &&
            s.systemStatus.proxyConnection &&
            s.systemStatus.proxyConnection.active
    );
